/* eslint-disable no-undef */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import { Divider } from '@material-ui/core';
import 'typeface-roboto';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    marginBottom: 5,
  },
  dialogContentStyle: {
    scrollbarWidth: 0,
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      width: '0px',
      background: 'transparent',
    },
  },
  titleStyle: {
    textAlign: 'center',
  },
  buttonActionsStyle: {
    justifyContent: 'space-between',
  },
  buttonStyle: {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
}));

const EditDialog = (props) => {
  const classes = useStyles();
  const {
    data, onSave, onClose, open,
  } = props;

  const [realname, setRealname] = React.useState('');
  const [addr1, setAddr1] = React.useState('');
  const [addr2, setAddr2] = React.useState('');
  const [addr3, setAddr3] = React.useState('');
  const [addr4, setAddr4] = React.useState('');
  const [addr5, setAddr5] = React.useState('');

  useEffect(() => {
    setRealname(data.usr_realname);
    setAddr1(data.usr_address1);
    setAddr2(data.usr_address2);
    setAddr3(data.usr_address3);
    setAddr4(data.usr_address4);
    setAddr5(data.usr_address5);
  }, [data]);

  useEffect(() => {
    if (open) {
      setRealname(data.usr_realname);
      setAddr1(data.usr_address1);
      setAddr2(data.usr_address2);
      setAddr3(data.usr_address3);
      setAddr4(data.usr_address4);
      setAddr5(data.usr_address5);
    }
  }, [open, data]);

  const handleSave = () => {
    data.usr_realname = realname;
    data.usr_address1 = addr1;
    data.usr_address2 = addr2;
    data.usr_address3 = addr3;
    data.usr_address4 = addr4;
    data.usr_address5 = addr5;
    onSave(data);
  };

  const handleClose = () => {
    onClose();
  };

  const handleChange = (e) => {
    if (e.target.name === 'realname') {
      setRealname(e.target.value);
    }
    if (e.target.name === 'addr1') {
      setAddr1(e.target.value);
    }
    if (e.target.name === 'addr2') {
      setAddr2(e.target.value);
    }
    if (e.target.name === 'addr3') {
      setAddr3(e.target.value);
    }
    if (e.target.name === 'addr4') {
      setAddr4(e.target.value);
    }
    if (e.target.name === 'addr5') {
      setAddr5(e.target.value);
    }
  };

  return (
    <Dialog maxWidth="xs" onClose={handleClose} fullWidth aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle className={classes.titleStyle} id="simple-dialog-title">Alamat Lengkap</DialogTitle>
      <DialogContent className={classes.dialogContentStyle}>
        <TextField fullWidth autoComplete="off" name="realname" placeholder="Nama Lengkap" defaultValue={realname} onChange={handleChange} />
        <TextField fullWidth autoComplete="off" name="addr1" defaultValue={addr1} onChange={handleChange} />
        <TextField fullWidth autoComplete="off" name="addr2" defaultValue={addr2} onChange={handleChange} />
        <TextField fullWidth autoComplete="off" name="addr3" defaultValue={addr3} onChange={handleChange} />
        <TextField fullWidth autoComplete="off" name="addr4" defaultValue={addr4} onChange={handleChange} />
        <TextField fullWidth autoComplete="off" name="addr5" defaultValue={addr5} onChange={handleChange} />
      </DialogContent>
      <DialogActions className={classes.buttonActionsStyle}>
        <Button className={classes.buttonStyle} onClick={handleClose} color="primary" variant="contained">
          TUTUP
        </Button>
        <Button className={classes.buttonStyle} onClick={handleSave} color="primary" variant="contained" autoFocus>
          SIMPAN
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const UsrAlamatLengkap = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const { data, onChange } = props;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSave = (dt) => {
    onChange(dt);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Card className={classes.cardWrapper}>
      <CardHeader
        title="Alamat Lengkap"
        subheader="Digunakan untuk alamat paket pengiriman"
      />
      <CardActionArea onClick={handleClickOpen}>
        <CardContent style={{ minHeight: 100 }}>
          <Typography variant="body1">{data.usr_realname}</Typography>
          <Divider />
          <Typography variant="body1">{data.usr_address1}</Typography>
          <Divider />
          <Typography variant="body1">{data.usr_address2}</Typography>
          <Divider />
          <Typography variant="body1">{data.usr_address3}</Typography>
          <Divider />
          <Typography variant="body1">{data.usr_address4}</Typography>
          <Divider />
          <Typography variant="body1">{data.usr_address5}</Typography>
          <Divider />
        </CardContent>
      </CardActionArea>
      <EditDialog data={data} onSave={handleSave} onClose={handleClose} open={open} />
    </Card>
  );
};

export default UsrAlamatLengkap;
